import { AbstractControl, ValidatorFn } from '@angular/forms';

export function usernameValidator(): ValidatorFn {
  return (control: AbstractControl<string>): { [key: string]: any } | null => {
    const usernameRegex = new RegExp('^(?!.*[._]{2})[a-zA-Z0-9]+(?:[_\\.][a-zA-Z0-9]+)*$');
    const isValid = usernameRegex.test(control.value);
    return isValid ? null : { invalidUsername: true };
  };
}
